import React, { useState, useEffect } from 'react';

const COOKIE_STORAGE_KEY = 'cookieConsentStatus'; // 'accepted' | 'denied' | null

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const status = localStorage.getItem(COOKIE_STORAGE_KEY);
        if (!status) {
            setIsVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem(COOKIE_STORAGE_KEY, 'accepted');
        setIsVisible(false);
    };

    const denyCookies = () => {
        localStorage.setItem(COOKIE_STORAGE_KEY, 'denied');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div style={styles.banner}>
            <p style={styles.text}>
                Diese Website verwendet Cookies, um bestmögliche Funktionalität zu gewährleisten.
            </p>
            <div>
                <button onClick={acceptCookies} style={{ ...styles.button, ...styles.accept }}>
                    Akzeptieren
                </button>
                <button onClick={denyCookies} style={{ ...styles.button, ...styles.deny }}>
                    Ablehnen
                </button>
            </div>
        </div>
    );
};

const styles = {
    banner: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#222',
        color: 'white',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 10000,
        flexWrap: 'wrap',
    },
    text: {
        margin: 0,
        fontSize: '1rem',
        flex: '1 1 300px',
    },
    button: {
        border: 'none',
        padding: '0.5rem 1rem',
        fontSize: '1rem',
        borderRadius: '4px',
        cursor: 'pointer',
        marginLeft: '0.5rem',
    },
    accept: {
        backgroundColor: '#4caf50',
        color: 'white',
    },
    deny: {
        backgroundColor: '#f44336',
        color: 'white',
    },
};

export default CookieConsent;
